"use client";
import SlideShowSwiper from "./swiper-slide";
import TitleContent from "./title-content";
import MobileCarousel from "./mobile-carousel";
import { useWinnersCtx } from "@/contexts/winners";
import { Winner } from "@/types/gallery";
import { useWindowSize } from "@/hooks/use-window-size";
import { useEffect, useState } from "react";

export default function MainContent() {
  const { winners } = useWinnersCtx();
  const { width } = useWindowSize();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const filteredWinners = (winners as Winner[])?.filter((winner: Winner) => winner.image_link);

  if (!isMounted) {
    return (
      <div className="mx-auto w-[85%] pb-80 lg:w-[90%] lg:pb-20">
        <TitleContent />
      </div>
    );
  }

  const isMobile = width !== undefined && width < 1024;

  return (
    <div className="mx-auto w-[85%] pb-80 lg:w-[90%] lg:pb-20">
      <TitleContent />
      {isMobile ? (
        <MobileCarousel winners={filteredWinners} />
      ) : (
        <SlideShowSwiper winners={filteredWinners} />
      )}
    </div>
  );
}
